import './Record.css';

const EDUCATION = [
  {
    school: 'University Politehnica of Timișoara',
    degree: "Master's — Control Systems Engineering",
    faculty: 'Faculty of Automation and Computers',
    years: '2025 — 2027',
    now: true,
  },
  {
    school: 'West University of Timișoara',
    degree: "Bachelor's — Computer Science",
    faculty: 'Faculty of Mathematics and Computer Science',
    years: '2022 — 2025',
  },
  {
    school: '"Regina Maria" National College',
    degree: 'Mathematics & Computer Science',
    faculty: 'High School Diploma',
    years: '2018 — 2022',
  },
];

const CERTS = [
  {
    name: 'Learn SQL',
    org: 'Codecademy',
    date: 'Nov 2024',
    url: 'https://www.codecademy.com/profiles/rarespoanta/certificates/042a4e5884e3eb6ea1f2a12be6abb851',
  },
  {
    name: 'SAP S/4HANA Essential Training',
    org: 'LinkedIn Learning',
    date: 'Nov 2024',
    url: 'https://www.linkedin.com/learning/certificates/0decf084d9c18f56db4f8417133f65e259faae7266059f9898533507baf3c3e2',
  },
  {
    name: 'SAP Human Capital Management',
    org: 'LinkedIn Learning',
    date: 'Nov 2024',
    url: 'https://www.linkedin.com/learning/certificates/ae56fc37321309fbdfbe18f268fca2ca110931a5641bc910fe7b395e0b76fc2b',
  },
];

const Arrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
  </svg>
);

export default function Record() {
  return (
    <section id="record" className="band rc">
      <div className="shell">

        <div className="sec-head" data-rv="up">
          <span className="sec-tag"><b>07</b> — Record</span>
          <h2 className="display-lg">
            <span className="mask-line"><span>Credentials,</span></span>
            <span className="mask-line" style={{ '--ml-d': '110ms' }}><span>verifiable.</span></span>
          </h2>
        </div>

        <div className="rc-grid">

          {/* ── Education ─────────────────────────────────── */}
          <div className="rc-col" data-rv="up">
            <div className="rc-col-head">
              <span className="mono">Education</span>
              <span className="rc-col-rule" />
            </div>

            {EDUCATION.map((e, i) => (
              <article
                className="rc-edu"
                key={e.school}
                data-rv="up"
                style={{ '--rv-d': `${80 + i * 90}ms` }}
              >
                <div className="rc-edu-top">
                  <h3 className="rc-edu-school">{e.school}</h3>
                  {e.now && <span className="avail avail--sm"><i className="avail-led" />In progress</span>}
                </div>
                <p className="rc-edu-degree">{e.degree}</p>
                <div className="rc-edu-meta">
                  <span>{e.faculty}</span>
                  <span className="rc-edu-years">{e.years}</span>
                </div>
              </article>
            ))}
          </div>

          {/* ── Certificates ──────────────────────────────── */}
          <div className="rc-col" data-rv="up" style={{ '--rv-d': '120ms' }}>
            <div className="rc-col-head">
              <span className="mono">Certifications</span>
              <span className="rc-col-rule" />
            </div>

            {CERTS.map((c, i) => (
              <a
                className="rc-cert"
                key={c.name}
                href={c.url}
                target="_blank"
                rel="noopener noreferrer"
                data-rv="up"
                style={{ '--rv-d': `${140 + i * 90}ms` }}
              >
                <span className="rc-cert-body">
                  <span className="rc-cert-name">{c.name}</span>
                  <span className="rc-cert-meta">{c.org} · {c.date}</span>
                </span>
                <span className="rc-cert-cta">
                  Verify
                  <span className="rc-cert-ico"><Arrow /></span>
                </span>
              </a>
            ))}

            <div className="rc-lang" data-rv="up" style={{ '--rv-d': '420ms' }}>
              <span className="mono">Languages</span>
              <div className="rc-lang-list">
                <span>Romanian — native</span>
                <span>English — professional</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
